// Port of api/fuel/app/classes/controller/api/monty/tags/update.php
import DB from 'offline/db'
import {
	invalid,
	loadOwnedTag,
	persist,
	sessionUserId,
	tagToArray,
	unauthorised,
	validateTagData
} from './shared'

export default function(params) {
	var userId = sessionUserId(params)
	var tag = false
	var data = params.data || {}

	if (!userId) {
		return unauthorised()
	}

	tag = loadOwnedTag(userId, params.tag)
	if (!tag) {
		return unauthorised()
	}

	data.context = parseInt(tag.tag_context, 10) || 0
	if (!validateTagData(data)) {
		return invalid()
	}

	DB.run('UPDATE tag SET tag_public = ?, tag_text = ?, tag_colour = ?, tag_fore = ? WHERE tag_id = ?', [
		parseInt(data.public, 10) || 0,
		String(data.text || '').trim(),
		String(data.colour || ''),
		String(data.fore || ''),
		parseInt(tag.tag_id, 10) || 0
	])

	var rows = DB.query('SELECT * FROM tag WHERE tag_id = ?', [tag.tag_id])
	return persist(tagToArray(rows[0]))
}
